import React from 'react';
import Logo from '../../image/stalion__logo.svg';
import './index.css';

const Footer = () => {
  return (
    <footer className="foot">
      <ul className="footer__socials">
        <li className="footer__social"><a href="https://www.instagram.com/3elementsdesign/">Instagram</a></li>
        <li className="footer__social"><a href="https://www.facebook.com/3elementsdesign/">Facebook</a></li>
        <li className="footer__social"><a href="https://twitter.com/WeAre3ED">Twitter</a></li>
      </ul>
      <div className="footer__contact">
        <a href="tel:5107706076" className="footer__phone">510.770.6076</a>
        <a href="mailto:info@3elements.design" className="footer__mail">info@3elements.design</a>
        <img src={Logo} alt="Stalion"/>
      </div>
    </footer>
  );
}

export default Footer;
